'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getUserId = require('./cookie/getUserId');

var _getUserId2 = _interopRequireDefault(_getUserId);

var _getPreviousId = require('./cookie/getPreviousId');

var _getPreviousId2 = _interopRequireDefault(_getPreviousId);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function alias() {
    var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _getUserId2.default)();
    var previousId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _getPreviousId2.default)();

    return new Promise(function (resolve) {
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        global.analytics.alias(userId, previousId, null, resolve);
    });
}

exports.default = alias;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/alias.js
// module id = 1387
// module chunks = 1